import { Component, Input, Output, OnInit, ViewChild, TemplateRef, EventEmitter, SimpleChange } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Observable, Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';

import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap/modal/modal.module';

import { CalendarEvent, CalendarEventTimesChangedEvent, CalendarDateFormatter } from 'angular-calendar';
import { colors, division_colors } from '../colors'
import { CalendarFormatter } from '../calendar-common/calendar-formatter.provider'
import { AuthService } from '../Services/auth.service';
import { CalendarService } from '../Services/calendar.service';
import { ListService } from '../Services/list.service';
import { Logininfo } from '../classes/Loginifo';
import { StringUtil } from '../classes/StringUtil';
import { CustomerInputService } from '../Services/customer-input.service';
import { promise } from 'selenium-webdriver';
import { tick } from '@angular/core/src/render3';

@Component({
	selector: 'app-personal-calendar',
	templateUrl: './personal-calendar.component.html',
	styleUrls: ['./personal-calendar.component.css'],
	providers: [
		{
			provide: CalendarDateFormatter,
			useClass: CalendarFormatter
		}
	]
})

export class PersonalCalendarComponent implements OnInit {
	//	@ViewChild('eventDetailCustomer') eventDetailCustomer: TemplateRef<any>;
	//	@ViewChild('eventDetailEvent') eventDetailEvent: TemplateRef<any>;
	//	@ViewChild('eventDetailOther') eventDetailOther: TemplateRef<any>;
	@ViewChild('eventAdd') eventAdd: TemplateRef<any>;
	@ViewChild('cstEventView') cstEventView: TemplateRef<any>;
	@Input() viweuser: string;
	@Input() isedit: string;
	@Input()
	set pcalref(val: boolean) {
		//console.log('pcalref', val);
		if (val) {
			this.getCalendar(this.viewDate);
			this.pcalChange.emit(false);
		}
	}
	@Output() pcalChange = new EventEmitter<boolean>();
	eventTemplate: TemplateRef<any> | null = null;
	refresh: Subject<any> = new Subject();
	modalReference: NgbModalRef;

	logininfo: Logininfo = this.auth.loginID;
	view: string = 'week';
	viewDate: Date = new Date();
	locale: string = 'ja';
	eventTypeVal: string = '1';
	selectedViewType: string = 'bef';
	isNew: boolean = false;
	allEvents: any[] = [];
	viewEvents: any[] = [];
  customerList: any[] = [];
  eventAllList: any = [];
  eventList: any = [];
	place_list: any;
  app_place_list: any;
	dispEvent: any = {
		id: '',
		title: '',
		start: '',
		end: '',
		startTime: '',
		endTime: '',
		allDay: false,
		meta: {
			type: '',
			contents: '',
			division: { division_code: '' },
			sales: { user_code: '' },
			user: { user_code: '' },
			customer: {},
			event: {},
			child: [],
			other: [],
			holiday: '',
			place: { place_id: '' }
		}
	};
	dispCstEvent: any;
	fcdc_flg = true;

	constructor(
		private modal: NgbModal,
		public datePipe: DatePipe,
		public auth: AuthService,
		private router: Router,
		private calendar: CalendarService,
		private list: ListService,
		public customerInputService: CustomerInputService,
	) { }

	ngOnInit() {
		this.getCustomer();
		this.getCalendar(this.viewDate);
		this.viewEvents = [];
		this.getLists();
		this.getEventList(new Date());
	}
	getLists() {
		//面談履歴：場所表示用
		let place_list = this.customerInputService.placeList(0);
		place_list.subscribe(place_list => {
			this.place_list = place_list;
			//console.log( this.place_list );
      this.app_place_list = this.place_list.filter(place=>{
        return !place.sold;
      })
		});
	}
	getCalendar(date: Date) {
		this.allEvents = [];
		this.calendar.getUserCal(this.viweuser ? this.viweuser : this.logininfo.user_code, null,
			this.viewDate.getFullYear(),
			this.viewDate.getMonth() + 1,
			this.viewDate.getDate(),
			this.logininfo.user_code
		).subscribe((data: any[]) => {
			data.forEach(event => {
				let ev = this.json2CalEvent(event);
				this.allEvents.push(ev);
			});
			//console.log('getCalendar', data, this.allEvents);
			this.filterEvent();
			this.refresh.next();
		});
	}
	filterEvent() {
		this.viewEvents = this.allEvents.filter((val) => {
			return true;
		});
	}
	getCustomer() {
		this.customerList = [];

		this.list.getCustomerList(this.logininfo.user_code, { condition: '<=', value: '9' }
		).subscribe((data: any) => {
			data.forEach((cst) => {
				let name = cst.customer_name;
				let kana = cst.kana_name;
				this.customerList.push({ customer_code: cst.customer_code, customer_name: name, customer_kana: kana });
			});
		});
	}
	getEventList(date: Date) {
		this.eventList = [];
		return this.calendar.getEeventCal(0,
			date.getFullYear(),
			date.getMonth() + 1,
			date.getDate(),
			this.auth.getUserCode(),
			'1'
		).subscribe((data: any[]) => {
			data.forEach(event => {
				let ev = this.eventjson2CalEvent(event);
				this.eventAllList.push(ev);
			});
		});

	}
	dayClicked(date: Date) {
		if (this.isedit != '1') return;
		this.isNew = true;
		Promise.resolve(
		).then(() => {
			//return this.getEventList(date);
		}).then(() => {
			this.dispEvent = {
				id: '',
				title: '',
				start: StringUtil.date2Object(date),
				end: {},
				startTime_hour: '',
				startTime_minute: '',
				endTime_hour: '',
				endTime_minute: '',
				allDay: false,
				meta: {
					type: '1',
					contents: '',
					division: { division_code: '' },
					sales: { user_code: '' },
					user: { user_code: '' },
					customer: {},
					event: {},
					child: [],
					other: [],
					holiday: '',
					place: { place_id: '' }
				}
			};
			this.viewEventInfo();
		});
	}
	hourSegmentClicked(date: Date) {
		if (this.isedit != '1') return;
		this.isNew = true;
		var endDate = new Date(date.getTime());
		var startDate = StringUtil.date2Object(date);
		endDate.setHours(endDate.getHours() + 1); // デフォルトで1時間後
		Promise.resolve(
		).then(
			() => {
				//return this.getEventList(date);
			}
		).then(
			() => {
				this.dispEvent = {
					id: '',
					title: '',
					start: startDate,
					end: startDate,
					startTime_hour: this.datePipe.transform(date, "H"),
					startTime_minute: this.datePipe.transform(date, "mm"),
					endTime_hour: this.datePipe.transform(endDate, "H"),
					endTime_minute: this.datePipe.transform(endDate, "mm"),
					allDay: false,
					meta: {
						type: '1',
						contents: '',
						division: { division_code: '' },
						sales: { user_code: '' },
						user: { user_code: '' },
						customer: {},
						event: {},
						child: [],
						other: [],
						holiday: '',
						place: { place_id: '' }
					}
				}
				this.viewEventInfo();
			}
		);
	}
	eventClicked({ event }: { event: CalendarEvent }) {
		if (event.title == "週報提出日") {
			this.router.navigate(['/report-edit']);
			return;
		}
		if (event.title == "日報未提出") {
			this.router.navigate(['/day']);
			return;
		}
		if (event.meta.sub_type == "bef") {
			this.isNew = false;
			this.dispEvent = this.calEvent2ViewInfo(event);
			Promise.resolve(
			).then(
				() => {
					//return this.getEventList(event.start);
				}
			).then(
				() => {
					this.filterEventList(this.dispEvent);
					this.viewEventInfo();
				}
			);
		} else {
			this.dispCstEvent = this.calEvent2ViewInfo(event);
			this.viewCstEventInfo();
		}
	}
	onTypeChange(viewtype: string) {
		this.selectedViewType = viewtype;
	}

	changeInputType() {
		/*
		if (this.dispEvent.meta.type === '2') {
			this.eventTemplate = this.eventDetailEvent;
		} else if (this.dispEvent.meta.type === '3') {
			this.eventTemplate = this.eventDetailOther;
		} else {
			this.eventTemplate = this.eventDetailCustomer;
		}
		*/
	}
	viewEventInfo() {
		if (this.isedit != '1') return;
		//this.changeInputType();
		this.modalReference = this.modal.open(this.eventAdd, { centered: true });
		this.modalReference.result.then((result) => {
			if (result == 'ok' || result == '登録') {
				this.addCalendar();
			}
		});
	}
	viewCstEventInfo() {
		this.modalReference = this.modal.open(this.cstEventView, { centered: true });
		this.modalReference.result.then((result) => { });
	}
	addCalendar() {
		if (this.isedit != '1') return;
		this.modalReference.close();
		var event = this.viewInfo2CalEvent(this.dispEvent);
		//this.allEvents = [];
		this.calendar.setUserCal(this.logininfo.user_code, event, this.logininfo.user_code
		).subscribe((data) => {
			this.getCalendar(this.viewDate);
			this.pcalChange.emit(true);
		});
	}
	delCalendar() {
		if (this.isedit != '1') return;
		this.modalReference.close();
		var event = this.viewInfo2CalEvent(this.dispEvent);
		//this.allEvents = [];
		this.calendar.delUserCal(event, this.logininfo.user_code
		).subscribe((data) => {
			this.getCalendar(this.viewDate);
			this.pcalChange.emit(true);
		});
	}
	viewInfo2CalEvent(info: any) {
		let startDate = info.allDay ? StringUtil.Object2Str(info.start, '00:00') : StringUtil.Object2Str(info.start, info.startTime_hour + ":" + info.startTime_minute);
		let endDate = (!info.allDay && info.start && info.endTime_hour && info.endTime_minute) ? StringUtil.Object2Str(info.start, info.endTime_hour + ":" + info.endTime_minute) : null;
		/*
				var event = {
					id: info.id ? info.id : null,
					title: info.title,
					start: startDate,
					end: endDate,
					allDay: info.allDay,
					meta: Object.assign({}, info.meta)
				}
		*/
		var event = {
			id: info.id ? info.id : null,
			title: info.title,
			start: startDate,
			end: endDate,
			allDay: false,
			meta: Object.assign({}, info.meta)
		}
		if (event.meta.user.user_code) {
		} else {
			event.meta.user.user_code = this.logininfo.user_code;
		}
		if (event.meta.sales.user_code) {
		} else {
			event.meta.sales.user_code = this.logininfo.user_code;
		}
		return event;
	}

	json2CalEvent(info: any) {
		var calColor;
		if (info.title == '週報提出日' || info.title == '日報未提出') {
			// 週報・日報
			if (info.title == '週報提出日') {
				if (info.meta.is_filing) {
					calColor = colors.blue2;
				} else {
					calColor = colors.blue;
				}
			} else {
				calColor = colors.red;
			}
			let event = {
				title: info.title,
				start: new Date(info.start),
				end: null,
				allDay: info.allDay,
				meta: Object.assign({}, info.meta),
				color: calColor
			}
			return event;
		}
		//console.log(info);
		if (info.meta.user && info.meta.user.division) {
			switch (info.meta.user.division.division_code) {
				case 1:
					calColor = division_colors.niconico;
					break;
				case 2:
					calColor = division_colors.hiraya;
					break;
				case 3:
					calColor = division_colors.tochi;
					break;
				default:
					calColor = division_colors.niconico;
			}
		} else {
			calColor = colors.red;
		}
		let event = {
			id: info.id ? info.id : null,
			title: info.title,
			start: new Date(info.start),
			end: info.end ? new Date(info.end) : null,
			allDay: info.allDay,
			meta: Object.assign({}, info.meta),
			color: calColor
		}
		return event;
	}
	eventjson2CalEvent(info: any) {
		var color;
		switch (info.meta.division.division_code) {
			case 1:
				color = division_colors.niconico;
				break;
			case 2:
				color = division_colors.hiraya;
				break;
			case 3:
				color = division_colors.tochi;
				break;
			default:
				color = division_colors.niconico;
		}
		var event = {
			id: info.id ? info.id : null,
			title: info.title,
			start: new Date(info.start),
			end: info.end ? new Date(info.end) : null,
			allDay: info.allDay,
			meta: Object.assign({}, info.meta),
			color: color
		}
		return event;
	}
	calEvent2ViewInfo(event: any) {
		let startDate = StringUtil.date2Object(event.start);
		let endDate = StringUtil.date2Object(event.end);
		let startTime = StringUtil.date2ObjectTime(event.start);
		let endTime = StringUtil.date2ObjectTime(event.end);
		var info = {
			id: event.id ? event.id : null,
			title: event.title,
			start: startDate,
			end: (!event.allDay && endDate) ? endDate : null,
			startTime_hour: startTime ? startTime.hours : null,
			startTime_minute: startTime ? startTime.minutes : null,
			endTime_hour: (!event.allDay && endTime) ? endTime.hours : null,
			endTime_minute: (!event.allDay && endTime) ? endTime.minutes : null,
			allDay: event.allDay,
			meta: Object.assign({}, event.meta)
		}
		return info;
	}
	//顧客詳細へ
	customerDetail(id) {
		this.modalReference.close();
		this.router.navigate(['/detail/' + id]);
	}

	//面談用時間絞込(新規・追加)
	ed_setHour: any;
	ed_setMinute: any;
	ft_setMinute: any;
	edTimeSet() {
		//時
		if (this.dispEvent.startTime_hour) {
			this.ed_setHour = this.dispEvent.startTime_hour;
			if (!this.dispEvent.startTime_minute) {
				this.dispEvent.startTime_minute = 0;
			}
		}

		//分
		if (this.dispEvent.endTime_hour) {
			if (this.dispEvent.endTime_hour == this.ed_setHour) {
				if (this.dispEvent.startTime_minute == 45) {
					this.ed_setMinute = 0;
					this.dispEvent.endTime_hour = parseInt(this.dispEvent.endTime_hour) + 1;
					this.dispEvent.endTime_minute = 0;
				} else {
					this.ed_setMinute = parseInt(this.dispEvent.startTime_minute) + 1;
					if (!this.dispEvent.endTime_minute || this.ft_setMinute > this.dispEvent.endTime_minute) {
						if (this.ft_setMinute == 1) {
							this.dispEvent.endTime_minute = 15;
						} else if (this.ft_setMinute == 16) {
							this.dispEvent.endTime_minute = 30;
						} else if (this.ft_setMinute == 31) {
							this.dispEvent.endTime_minute = 45;
						}
					}
				}
			} else {
				this.ed_setMinute = 0;
				if (!this.dispEvent.endTime_minute) {
					this.dispEvent.endTime_minute = 0;
				}
			}
		}

		if (this.dispEvent.start_minute) {
			if (this.dispEvent.start_minute == 45) {
				this.ed_setHour = parseInt(this.dispEvent.startTime_hour) + 1;
			}
		}

	}
  getFcdc() {
    if (!this.dispEvent.meta.customer.customer_code) return;
    let fcdc = this.customerInputService.customerFcDoneCheck(this.dispEvent.meta.customer.customer_code);
    fcdc.subscribe(fcdc => {
      if (fcdc) {
        this.fcdc_flg = false;
        if (this.dispEvent.title == '初回面談') {
          this.dispEvent.title = '';
        }
      } else {
        this.fcdc_flg = true;
      }
      this.filterEventList(this.dispEvent);
    });
  }
	filterEventList(view) {
		if (!view.start) return;
		let selectDate = StringUtil.Object2Str(view.start);
		this.eventList = this.eventAllList.filter((event) => {
			let startDate = this.getDate(event.start);
			let endDate = this.getDate(event.end);
			return !!(selectDate >= startDate && selectDate <= endDate);
    });

	}
  getDate(datetime) {
    // datetimeの文字列から から dateのみの文字列にする
    let dt = new Date(datetime);
    return StringUtil.date2Str(new Date(datetime));
  }

}
